module.exports = __webpack_public_path__ + "static/img/v.5f4d96d2.png";